import { useState, useEffect, useMemo } from "react";
import OrderApi from "../../../api/OrderApi";
import PageNavigation from "../../pageNavigation/PageNavigation";
import { formatDateYYYMMDD } from "../../../util/dateUtil";
import { formatNumber } from "../../../util/Number";

const formatOrderDateLabel = (timestamp) => {
    const formatted = formatDateYYYMMDD(timestamp);
    return formatted ? formatted.replace(/-/g, ".") : "";
};

const getOrderDisplay = (order) => {
    let title = order.order_prod_title;
    let price = order.order_prod_price;

    if (order.order_prod === 30000) {
        title = `${title} (${order.order_addi_info})`;
        price = order.order_prod_price * order.order_cnt;
    }

    return {
        title,
        priceLabel: `${formatNumber(price)}원`,
        status: "결제완료",
        expireDate: formatDateYYYMMDD(order.order_exp_dtm),
    };
};

const groupOrdersByDate = (orders) => {
    const groups = [];
    const map = new Map();

    orders.forEach((order) => {
        const date = formatOrderDateLabel(order.order_create_dtm);
        if (!map.has(date)) {
            const group = { date, orders: [] };
            map.set(date, group);
            groups.push(group);
        }
        map.get(date).orders.push(order);
    });

    return groups;
};

const MyOrder = () => {
    const [totalCnt, setTotalCnt] = useState(0);
    const [orders, setOrders] = useState([]);

    const orderGroups = useMemo(() => groupOrdersByDate(orders), [orders]);

    const handlePageChg = async (page) => {
        const res = await OrderApi.getOrders(page);
        setOrders(res);
    };

    useEffect(() => {
        OrderApi.getOrders(1, true).then((res) => {
            setTotalCnt(res.totalCnt);
        });
    }, []);

    return (
        <section className="mypage-container">
            <section className="order-history">
                {orderGroups.map((group) => (
                    <div key={group.date} className="order-history-group">
                        <h3 className="order-history-date">{group.date}</h3>

                        {group.orders.map((order) => {
                            const display = getOrderDisplay(order);
                            return (
                                <article
                                    key={order.order_id}
                                    className="order-history-card"
                                >
                                    <div className="order-history-info">
                                        <strong className="order-history-status">
                                            {display.status}
                                        </strong>
                                        <p className="order-history-name">{display.title}</p>
                                        <p className="order-history-price">{display.priceLabel}</p>
                                    </div>

                                    <div className="order-history-expire">
                                        <span>만료일</span>
                                        <strong>{display.expireDate}</strong>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                ))}

                <PageNavigation
                    totalCount={totalCnt}
                    showCount={30}
                    onChange={handlePageChg}
                />
            </section>
        </section>
    );
};

export default MyOrder;
